// D-038 section switcher: a white bar of icon + label buttons; the active one gets the brand tint,
// a gradient icon and gradient text (D-039). Used where one page holds several sections.
import { cx, Icon, type IconName } from "@ady/ui";

export interface SectionBarItem {
  id: string;
  label: string;
  icon: IconName;
}

export function SectionBar({
  label,
  items,
  value,
  onChange,
}: {
  label: string;
  items: SectionBarItem[];
  value: string;
  onChange: (id: string) => void;
}) {
  return (
    <div
      role="tablist"
      aria-label={label}
      className="ady-scroll-quiet flex w-fit max-w-full gap-1 overflow-x-auto rounded-xs border border-card bg-surface p-1"
    >
      {items.map((it) => {
        const on = it.id === value;
        return (
          <button
            key={it.id}
            type="button"
            role="tab"
            aria-selected={on}
            onClick={() => onChange(it.id)}
            className={cx(
              "flex min-h-control flex-none items-center gap-2 rounded-xs px-3 text-sm font-medium",
              on ? "ady-bg-brand-tint" : "text-fg-secondary hover:bg-hover",
            )}
          >
            <Icon name={it.icon} size={16} gradient={on} />
            <span className={on ? "ady-text-brand" : undefined}>{it.label}</span>
          </button>
        );
      })}
    </div>
  );
}
